import * as React from "react";
import NavLink from "app/_components/layout/navigation/nav-link";

import {
  SubMenuHeadline,
  SubMenuDescription,
  SubMenuContainer,
  SubMenuLink,
  SubMenuText
} from "./styles";
import HoverUnderline from "components/parts/HoverUnderline";
import ArrowRight from "public/static/images/arrow-right-white-bg.svg";
import Picture from "components/parts/Picture";
export type SubMenuItemProps = {
  title?: string | React.ReactNode;
  link?: {
    href: string;
    text?: string;
    useReferrerPolicy?: boolean;
    id?: string;
  };
  hasArrow?: boolean;
  icon?: string;
  description?: string | React.ReactNode;
  isPrimaryItem?: boolean;
  showDescription?: boolean;
  region?: string;
  availability?: string;
  style?:
    | {
        [styleName: string]: string;
      }
    | React.CSSProperties;
  customFontSize?: string;
  newTab?: boolean;
  customLineHeight?: string;
  isHeading?: boolean;
};

const SubMenuItem = ({
  link,
  description,
  hasArrow,
  title,
  showDescription = true,
  region,
  availability,
  style,
  customFontSize,
  newTab,
  customLineHeight,
  isHeading = false
}: SubMenuItemProps) => {
  const [activeHover, setActiveHover] = React.useState(false);

  // Determine if we should compact the menu item (no extra space for description)
  const hasNoDescription =
    !description ||
    (typeof description === "string" && description.length === 0);
  const shouldCompact = !isHeading && hasNoDescription;
  const renderTitle = () => (
    <SubMenuHeadline
      semiBold
      lineHeight={customLineHeight}
      customFontSize={customFontSize}
      style={isHeading && style?.color ? { color: style.color } : undefined}
    >
      <HoverUnderline
        active={activeHover}
        customFontSize={customFontSize}
        customLineHeight={customLineHeight}
      >
        {title}
        {hasArrow && (
          <Picture
            style={{ paddingLeft: 12 }}
            src={ArrowRight.src}
            alt="arrow-right-institutional"
          />
        )}
      </HoverUnderline>
    </SubMenuHeadline>
  );

  const renderDescriptionContent = () => (
    <React.Fragment>
      {showDescription && availability && (
        <SubMenuText color={"secondary"}>{availability}</SubMenuText>
      )}
      {showDescription && description && (
        <SubMenuDescription
          style={
            isHeading
              ? {
                  textTransform: "uppercase",
                  fontWeight: "bold",
                  margin: "0"
                }
              : {}
          }
        >
          {description}
        </SubMenuDescription>
      )}
    </React.Fragment>
  );

  const renderSubMenu = () => (
    <SubMenuContainer
      key={title}
      onMouseEnter={() => setActiveHover(true)}
      onMouseLeave={() => setActiveHover(false)}
      showDescription={showDescription}
      wideMargin={region === "GB"}
      style={{
        ...style,
        // For items with no description, use minimal height and padding
        minHeight: shouldCompact ? "auto" : style?.minHeight || "70px",
        margin: shouldCompact ? "8px 0" : style?.margin || "0px 0px 24px 0px"
      }}
    >
      <div>
        {/* If there's a link, only make the title clickable */}
        {link?.href ? (
          <React.Fragment>
            <NavLink
              href={link.href}
              useReferrerPolicy={link.useReferrerPolicy}
              newTab={newTab}
              id={link.id}
            >
              {renderTitle()}
            </NavLink>
            {renderDescriptionContent()}
          </React.Fragment>
        ) : (
          <React.Fragment>
            {renderTitle()}
            {renderDescriptionContent()}
          </React.Fragment>
        )}
      </div>
      {link?.text && <SubMenuLink>{link.text}</SubMenuLink>}
    </SubMenuContainer>
  );

  return renderSubMenu();
};

export default SubMenuItem;
